import { AppointmentTriageFormInputs } from "../interfaces/AppointmentTriageFormInputs";

export const appointmentTriageEmpty: AppointmentTriageFormInputs = {
  pressure: "",
  temperature: "",
  weight: 0,
  height: 0,
};
